<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const auth = useAuthStore();

const id = ref("admin");
const password = ref("P@ssword");
const error = ref("");
const showRegister = ref(false);
const regId = ref("");
const regUsername = ref("");
const regPassword = ref("");
const regEmail = ref("");
const regError = ref("");
const regSuccess = ref("");

const onSubmit = async () => {
  error.value = "";
  const ok = await auth.login({
    id: id.value,
    password: password.value,
  });
  if (!ok || !ok.ok) {
    console.log("Login error message:", ok.error);
    error.value =
      ok && ok.error ? ok.error : "아이디 또는 비밀번호를 확인해주세요.";
    return;
  }
  router.push("/app");
};

const openRegister = () => {
  regId.value = "";
  regUsername.value = "";
  regPassword.value = "";
  regEmail.value = "";
  regError.value = "";
  regSuccess.value = "";
  showRegister.value = true;
};

const cancelRegister = () => {
  showRegister.value = false;
};

const submitRegister = async () => {
  regError.value = "";
  regSuccess.value = "";
  if (!regId.value || !regPassword.value) {
    regError.value = "아이디와 비밀번호는 필수입니다.";
    return;
  }
  const res = await auth.register({
    id: regId.value,
    password: regPassword.value,
    username: regUsername.value || undefined,
    email: regEmail.value || undefined,
  });
  if (!res || !res.ok) {
    regError.value =
      res && res.error ? res.error : (res && res.message) || "등록 실패";
    return;
  }
  regSuccess.value = `등록 성공. 사용자 id=${res.id || "n/a"}`;
  // keep form visible or close
  showRegister.value = false;
};
</script>

<template>
  <div class="login-wrap">
    <div class="login-card">
      <h1 style="text-align: center">부동산 실거래정보</h1>
      <h1 style="text-align: center">로그인</h1>

      <form
        @submit.prevent="onSubmit"
        id="loginForm"
        name="loginForm"
        class="form"
      >
        <label>
          아이디
          <input id="id" v-model="id" autocomplete="id" />
        </label>

        <label>
          비밀번호
          <input
            id="password"
            v-model="password"
            type="password"
            autocomplete="current-password"
          />
        </label>

        <p v-if="error" class="error">{{ error }}</p>

        <button type="submit">로그인</button>
        <button
          type="button"
          @click.prevent="openRegister"
          style="background: #4caf50"
        >
          사용자 추가
        </button>
        <small class="hint">데모 계정: admin / P@ssword</small>
      </form>

      <div v-if="showRegister" class="register-panel">
        <h2>사용자 추가</h2>
        <label>
          id
          <input v-model="regId" />
        </label>
        <label>
          비밀번호
          <input v-model="regPassword" type="password" />
        </label>
        <label>
          사용자명
          <input v-model="regUsername" />
        </label>
        <label>
          이메일 (선택)
          <input v-model="regEmail" />
        </label>
        <p v-if="regError" class="error">{{ regError }}</p>
        <p v-if="regSuccess" style="color: #b3ffb3">{{ regSuccess }}</p>
        <div style="display: flex; gap: 8px; margin-top: 8px">
          <button @click.prevent="submitRegister" style="background: #4caf50">
            추가
          </button>
          <button @click.prevent="cancelRegister" style="background: #999">
            취소
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-wrap {
  height: 100vh;
  display: grid;
  place-items: center;
  background: radial-gradient(circle at 30% 20%, #2d8cff, #0b1d3a 70%);
}
.login-card {
  width: 360px;
  padding: 24px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  color: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}
.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}
label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
}
input {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
}
button {
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 0;
  background: #2d8cff;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}
.error {
  color: #ffb3b3;
  font-size: 13px;
  margin: 0;
}
.hint {
  opacity: 0.8;
}

/* ===== Mobile Responsive ===== */
@media (max-width: 600px) {
  .login-wrap {
    height: 100dvh;
    padding: 16px;
  }

  .login-card {
    width: 100%;
    max-width: 360px;
    padding: 20px;
    border-radius: 12px;
  }

  h1 {
    font-size: 1.6em;
    margin: 8px 0;
  }

  .form {
    gap: 10px;
    margin-top: 14px;
  }

  label {
    gap: 5px;
    font-size: 13px;
  }

  input {
    padding: 12px;
    font-size: 16px;
    min-height: 44px;
  }

  button {
    min-height: 44px;
    padding: 12px;
    margin-top: 6px;
    font-size: 14px;
  }

  .register-panel {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  .register-panel h2 {
    font-size: 1.2em;
    margin-top: 0;
    margin-bottom: 8px;
  }

  .register-panel label {
    margin-top: 4px;
  }

  .error {
    font-size: 12px;
  }
}

@media (max-width: 400px) {
  .login-card {
    padding: 16px;
  }

  h1 {
    font-size: 1.4em;
  }

  input {
    padding: 10px;
    font-size: 16px;
  }

  button {
    min-height: 40px;
    padding: 10px;
  }
}
</style>
